interface TestimonyI {
  name: string;
  job: string;
  title: string;
  text: string;
  avatar: string;
}

export const TestimoniesList: TestimonyI[] = [
  {
    name: "Luiz Amelotti",
    job: "Amelotti Tecnologia",
    title: "",
    text: `We work together on some projects and he is always ready to help others. 
    With a differentiated technical knowledge and a capacity for analysis, it was one of the key pieces in the success of the projects. 
    Able to easily adapt to the challenges presented, regardless of the technology used, 
    always adapting very easily to new products or concepts.`,
    avatar:
      "https://media-exp1.licdn.com/dms/image/C4E03AQELmswr8owt2w/profile-displayphoto-shrink_800_800/0/1527511504726?e=1657152000&v=beta&t=y60T9GT0HAPCoJZcG-WhL5tNPTyFwhSdtkdLKC1eNLU",
  },
  {
    name: "Leonardo Rosário",
    job: "Senior Cyber Security Engineer",
    title: "",
    text: `I had the pleasure of working with Diogenes on multiple projects, and I can confidently say he is an excellent developer. 
    His technical expertise, problem-solving skills, and commitment to delivering high-quality solutions always stood out. 
    Diogenes has a unique ability to understand complex requirements and transform them into effective, innovative implementations. 
    I highly recommend him to any team or organization looking for a dedicated and talented developer.`,
    avatar:
      "https://media-exp1.licdn.com/dms/image/C4D03AQE7Nx7TD9QINQ/profile-displayphoto-shrink_800_800/0/1611159293748?e=1657152000&v=beta&t=UGKDPyM8roirElYwpKRzBUk_P0G1TtcpIe_CnHB0u_k",
  },

  {
    name: "Paula Pfeiffer",
    job: "DBA",
    title: "",
    text: `Diogenes is a great developer, fast in solving problems and always thinking about the best technology, approach and development for his work. He has a lot of experience in integration, NoSQL and Nodejs, being this the mainly used blank we worked together.`,
    avatar:
      "https://media-exp1.licdn.com/dms/image/C4D03AQE7Nx7TD9QINQ/profile-displayphoto-shrink_800_800/0/1611159293748?e=1657152000&v=beta&t=UGKDPyM8roirElYwpKRzBUk_P0G1TtcpIe_CnHB0u_k",
  },
  {
    name: "Grasiela Gomes",
    job: "Frontend developer",
    title: "",
    text: `Dio is a problem solver, always looking for the best approach to design and develop new features`,
    avatar:
      "https://media-exp1.licdn.com/dms/image/C4D03AQE7Nx7TD9QINQ/profile-displayphoto-shrink_800_800/0/1611159293748?e=1657152000&v=beta&t=UGKDPyM8roirElYwpKRzBUk_P0G1TtcpIe_CnHB0u_k",
  },
  {
    name: "Paulo Santos",
    job: "NodeJS Developer",
    title: "",
    text: `Diogenes is a unique professional. As a colleague, I say that it is very good to work with him.
    He is always willing to help, is proactive, has a lot of technical knowledge, which adds a lot to the team, and is very studious, likes to research new things and share his knowledge.
    As an excellent professional, he always seeks the best solutions to problems.
    In short. He is the kind of professional and person that every company would like to have.`,
    avatar:
      "https://media-exp1.licdn.com/dms/image/C4D03AQGSPX1UrQyuRA/profile-displayphoto-shrink_800_800/0/1516802517078?e=1657152000&v=beta&t=D0efbu0a0HzULHu54bFsXQmSEOvvtpajfOqmbxlXPoU",
  },
];
